module.exports = __webpack_public_path__ + "static/media/sorrow-video.cb9def5e.mp4";